import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAPI, callPostAPI, callPutAPI } from '../../services/axios';

export const getAllopathys = createAsyncThunk(
	'getAllopathys',
	async(params, { rejectWithValue }) => {
		try {
			const { type, ...newParams } = params;
			const response = await callGetAPI({ route: `hospital/allopathy/${type}`, params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getAllopathyDetails = createAsyncThunk(
	'getAllopathyDetails',
	async(params, { rejectWithValue }) => {
		try {
			const { id, type } = params;
			const response = await callGetAPI({ route: `hospital/allopathy/${type}/${id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const createAllopathy = createAsyncThunk(
	'createAllopathy',
	async(params, { rejectWithValue }) => {
		try {
			const { type, body } = params;
			const response = await callPostAPI({ route: `hospital/allopathy/${type}`, body });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateAllopathy = createAsyncThunk(
	'updateAllopathy',
	async(params, { rejectWithValue }) => {
		try {
			const { id, body, type } = params;
			const response = await callPutAPI({ route: `hospital/allopathy/${type}/${id}`, body });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);